var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Administrate = function Administrate(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m8.379 3.964 2.328 2.329A1 1 0 0 1 11 7v3a1 1 0 0 1-1 1H7a1 1 0 0 1-.707-.293L3.964 8.38a5 5 0 0 0 7.105 5.219 1 1 0 0 1 1.138.195l6 6a1.121 1.121 0 0 0 1.586-1.586l-6-6a1 1 0 0 1-.195-1.138 5 5 0 0 0-5.22-7.105Zm-2.31-1.366a7 7 0 0 1 9.61 8.667l5.528 5.528a3.121 3.121 0 1 1-4.414 4.414l-5.528-5.528a7 7 0 0 1-8.667-9.61 1 1 0 0 1 1.61-.276L7.413 9H9V7.414L5.793 4.207a1 1 0 0 1 .276-1.61Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Administrate;